module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workorder"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "full-box"
  }, [_c('div', {
    staticClass: "loadingWorkOrders"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v("\n        Loading Work Order #" + _vm._s(this.$route.params.id) + "           \n      ")])]) : _vm._e(), _vm._v(" "), (_vm.openMenu) ? [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close-menu",
    on: {
      "click": function($event) {
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mcText"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('br'), _c('br')])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('button', {
    staticClass: "pull-right btn header-btn mcBG scBGHover",
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Back to Listings")])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.showMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-header-bar mcBG"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('h1', [_vm._v("WO# " + _vm._s(_vm.workOrder.woNumber))])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('h1', [_vm._v("My Work Orders ")])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', {
    staticClass: "tablet-view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexrow"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("WO# " + _vm._s(_vm.workOrder.woNumber))]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOListing"
  }, [_c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.workOrder.situsNum) + " " + _vm._s(_vm.workOrder.situsLabel))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Contact Phone #:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "link"
    }
  }, [_vm._v(" " + _vm._s(_vm.workOrder.phone))])]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("City:")]), _vm._v(" " + _vm._s(_vm.workOrder.city) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Generated Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.workOrder.generatedDate, "MMM Do, YYYY")))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Scheduled Date: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.workOrder.scheduledDate, "MMM Do, YYYY")) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("District:")]), _vm._v(" " + _vm._s(_vm.workOrder.districtCode) + " | " + _vm._s(_vm.workOrder.districtName))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Lot:")]), _vm._v(" " + _vm._s(_vm.workOrder.lot) + " | "), _c('strong', {
    staticClass: "scText"
  }, [_vm._v("Block:")]), _vm._v(" " + _vm._s(_vm.workOrder.block) + " | "), _c('strong', {
    staticClass: "scText"
  }, [_vm._v("Section: ")]), _vm._v(" " + _vm._s(_vm.workOrder.section))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Subdivision:")]), _vm._v(" " + _vm._s(_vm.workOrder.subdivision))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Problem:")]), _vm._v(" " + _vm._s(_vm.workOrder.problemDescription))]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("UCC#:")]), _vm._v(" " + _vm._s(_vm.workOrder.ucc) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Priority: ")]), _vm._v(" " + _vm._s(_vm.workOrder.priority) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Prepared By:")]), _vm._v(" " + _vm._s(_vm.workOrder.preparedBy) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Comments:")]), _vm._v(" " + _vm._s(_vm.workOrder.woComments) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Meter #:")]), _vm._v(" " + _vm._s(_vm.workOrder.meterNumber) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("MTU #:")]), _vm._v(" " + _vm._s(_vm.workOrder.mtuNumber) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Current Meter Read:")]), _vm._v(" " + _vm._s(_vm.workOrder.currentMeterRead) + " ")]), _vm._v(" "), _c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Previous Meter Read:")]), _vm._v(" " + _vm._s(_vm.workOrder.previousMeterRead) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("Actions")]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOActions"
  }, [_c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.enterLabor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Labor (" + _vm._s(_vm.laborRecords.length) + ")")]), _vm._v(" "), _c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.enterEquipment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Equipment (" + _vm._s(_vm.equipRecords.length) + ")")]), _vm._v(" "), _c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.enterMaterial()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Materials (" + _vm._s(_vm.materialRecords.length) + ")")]), _vm._v(" "), _c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.enterNotes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Internal Notes (" + _vm._s(_vm.notesRecords.length) + ")")]), _vm._v(" "), (this.canUsePhotos) ? _c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.enterPhoto()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Photos (" + _vm._s(_vm.photoRecords.length) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.workOrder.fieldComplete) ? _c('li', {
    staticClass: "scTextHover",
    on: {
      "click": function($event) {
        return _vm.openWOcloseForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Close Work Order")]) : _vm._e()]), _vm._v(" "), (!_vm.workOrder.fieldComplete) ? _c('div', [_c('div', {
    staticClass: "closeWorkOrderContainer"
  }, [(!this.openWOform) ? _c('div', {
    staticClass: "top"
  }) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Close Work Order")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "solutioncode"
    }
  }, [_vm._v("Solution Code")]), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "popper-class": "popClass",
      "no-match-text": "No Solution Code Found",
      "filterable": "",
      "placeholder": "Select a Solution Code"
    },
    on: {
      "change": function($event) {
        return _vm.changeDescription()
      }
    },
    model: {
      value: (_vm.workOrder.solutionCode),
      callback: function($$v) {
        _vm.$set(_vm.workOrder, "solutionCode", $$v)
      },
      expression: "workOrder.solutionCode"
    }
  }, _vm._l((_vm.orderBy(_vm.solutionCodes, 'description', 1)), function(solution) {
    return (solution.department == _vm.workOrder.department) ? _c('el-option', {
      staticClass: "form-control",
      attrs: {
        "label": solution.description + ' (' + solution.solutionCode + ')',
        "value": solution.solutionCode
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repairdescription"
    }
  }, [_vm._v("Description of Repairs / Field Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workOrder.repairsDescription),
      expression: "workOrder.repairsDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "repairdescription"
    },
    domProps: {
      "value": (_vm.workOrder.repairsDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workOrder, "repairsDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.workOrder.solutionCode) ? _c('div', [_vm._m(1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.workOrder.fieldComplete) ? _c('div', [_c('h2', [_vm._v("This Work Order is Closed")]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOListing"
  }, [_c('li', [_c('strong', [_vm._v("Solution:")]), _vm._v(" "), _vm._l((_vm.solutionCodes), function(solution) {
    return (solution.solutionCode == _vm.workOrder.solutionCode) ? _c('span', {
      staticClass: "inline-block"
    }, [_vm._v("\n                " + _vm._s(solution.description))]) : _vm._e()
  })], 2), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Solution Code:")]), _vm._v(" " + _vm._s(_vm.workOrder.solutionCode) + " ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Completed Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.workOrder.completeDate, "MMM Do, YYYY")) + " ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Description of Repairs:")]), _vm._v(" " + _vm._s(_vm.workOrder.repairsDescription) + " ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "inner-dark"
  }, [_c('h3', {
    staticClass: "mcText"
  }, [_c('span', [_vm._v("Username")]), _vm._v("\n              " + _vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('br'), _c('br')])])])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('div', {
    staticClass: "mobile-view"
  }, [_c('div', {
    staticClass: "innerWOtopRow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 left"
  }, [_vm._m(2), _vm._v("\n                " + _vm._s(_vm.workOrder.situsNum) + " " + _vm._s(_vm.workOrder.situsLabel) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 right mcBG"
  }, [_vm._m(3), _vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.workOrder.generatedDate, "MMM Do, YYYY")) + "\n                "), _vm._m(4), _vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.workOrder.scheduledDate, "MMM Do, YYYY")) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "innerWOmainListing"
  }, [_c('p', [_c('strong', [_vm._v("Contact Phone #:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "link"
    }
  }, [_vm._v(_vm._s(_vm.workOrder.phone))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("City:")]), _vm._v(" " + _vm._s(_vm.workOrder.city) + " ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("District:")]), _vm._v(" " + _vm._s(_vm.workOrder.districtCode) + " | " + _vm._s(_vm.workOrder.districtName))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Lot:")]), _vm._v(" " + _vm._s(_vm.workOrder.lot) + " | "), _c('strong', {
    staticClass: "scText"
  }, [_vm._v("Block:")]), _vm._v(" " + _vm._s(_vm.workOrder.block) + " | "), _c('strong', {
    staticClass: "scText"
  }, [_vm._v("Section: ")]), _vm._v(" " + _vm._s(_vm.workOrder.section))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Problem:")]), _vm._v(" " + _vm._s(_vm.workOrder.problemDescription))]), _vm._v(" "), _c('p', {
    class: 'priority' + _vm.workOrder.priority
  }, [_c('strong', [_vm._v("Priority: ")]), _vm._v(" " + _vm._s(_vm.workOrder.priority))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Prep. By:")]), _vm._v(" " + _vm._s(_vm.workOrder.preparedBy) + " | "), _c('strong', [_vm._v("UCC#:")]), _vm._v(" " + _vm._s(_vm.workOrder.ucc))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Comments:")]), _vm._v(" " + _vm._s(_vm.workOrder.woComments))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Meter #:")]), _vm._v(" " + _vm._s(_vm.workOrder.meterNumber))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("MTU #:")]), _vm._v(" " + _vm._s(_vm.workOrder.mtuNumber))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Current Read:")]), _vm._v(" " + _vm._s(_vm.workOrder.currentMeterRead) + " | "), _c('strong', [_vm._v("Previous Read:")]), _vm._v(" " + _vm._s(_vm.workOrder.previousMeterRead))])]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOActions"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.enterNotes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Internal Notes (" + _vm._s(_vm.notesRecords.length) + ")")]), _vm._v(" "), (this.canUsePhotos) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.enterPhoto()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Photos (" + _vm._s(_vm.photoRecords.length) + ")")]) : _vm._e(), _vm._v(" "), (!this.openWOform) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.openWOcloseForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Close Work Order")]) : _vm._e()]), _vm._v(" "), (!_vm.workOrder.fieldComplete) ? _c('div', [(this.openWOform) ? _c('div', [_c('div', {
    staticClass: "innerWoCompletion"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "solutioncode"
    }
  }, [_vm._v("Solution Code")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select a Solution Code"
    },
    on: {
      "change": function($event) {
        return _vm.changeDescription()
      }
    },
    model: {
      value: (_vm.workOrder.solutionCode),
      callback: function($$v) {
        _vm.$set(_vm.workOrder, "solutionCode", $$v)
      },
      expression: "workOrder.solutionCode"
    }
  }, _vm._l((_vm.orderBy(_vm.solutionCodes, 'description', 1)), function(solution) {
    return (solution.department == _vm.workOrder.department) ? _c('el-option', {
      attrs: {
        "label": solution.description + ' (' + solution.solutionCode + ')',
        "value": solution.solutionCode
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repairdescription"
    }
  }, [_vm._v("Description of Repairs / Field Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workOrder.repairsDescription),
      expression: "workOrder.repairsDescription"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.workOrder.repairsDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workOrder, "repairsDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.workOrder.solutionCode) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn mcBG scBGHover",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Complete & Close WO")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.workOrder.fieldComplete) ? _c('div', [_c('h2', [_vm._v("This Work Order is Closed")]), _vm._v(" "), _c('ul', {
    staticClass: "innerWOListing"
  }, [_c('li', [_c('strong', {
    staticClass: "scText"
  }, [_vm._v("Solution:")]), _vm._v(" "), _vm._l((_vm.solutionCodes), function(solution) {
    return (solution.solutionCode == _vm.workOrder.solutionCode) ? _c('span', {
      staticClass: "inline-block"
    }, [_vm._v("\n          " + _vm._s(solution.description))]) : _vm._e()
  })], 2), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Solution Code:")]), _vm._v(" " + _vm._s(_vm.workOrder.solutionCode) + " ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Completed Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.workOrder.completeDate, "MMM Do, YYYY")) + " ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Description of Repairs:")]), _vm._v(" " + _vm._s(_vm.workOrder.repairsDescription) + " ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mobileBottomBar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.enterLabor()
      }
    }
  }, [_vm._v("\n              Labor "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.laborRecords.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 center",
    on: {
      "click": function($event) {
        return _vm.enterEquipment()
      }
    }
  }, [_vm._v("\n              Equipment "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.equipRecords.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.enterMaterial()
      }
    }
  }, [_vm._v("\n              Materials "), _c('span', {
    staticClass: "mcText"
  }, [_vm._v("(" + _vm._s(_vm.materialRecords.length) + ")")])])])])])]) : _vm._e(), _vm._v(" "), _c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("    " + _vm._s(_vm.$data) + "\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-image"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn mcBG scBGHover",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Complete & Close WO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Address")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Generated")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Scheduled")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c2880084!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkOrder.vue
// module id = 862
// module chunks = 2